import type { Transition } from "@uirouter/core";

import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { CLEARED_DATA_FILTER_URL_PARAMS } from "./prompts-widget/consts";

const CLEARED_FILTER_PARAMS = {
    ...CLEARED_DATA_FILTER_URL_PARAMS,
    quickFilter: undefined,
};

export const onRedirectToPromptsReport = (): transitionHookFn => {
    return (transition: Transition) => {
        const toParams = transition.params();
        const fromParams = transition.params("from");

        const wasCampaignChanged = fromParams?.campaignId && fromParams.campaignId !== toParams.campaignId;
        const areFiltersAlreadyCleared = Object.keys(CLEARED_FILTER_PARAMS).every((key) => toParams[key] == null);

        if (!wasCampaignChanged || areFiltersAlreadyCleared) {
            return;
        }

        return {
            params: {
                ...toParams,
                ...CLEARED_FILTER_PARAMS,
            },
        };
    };
};
